import * as React from 'react';
import { connect } from 'react-redux';

class PaymentMethods extends React.Component<any, any> {
  public render() {
    const {
      values,
      handleChange,
      cards,
      banks,
      companies,
    } = this.props;

    return (
      <div>
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>ID Compañia</label>
              <select
                className="form-control"
                name="data.companyId"
                onChange={handleChange}
                value={values.data.companyId}
              >
                <option value="">Indistinto</option>
                {
                  companies.map((company: any, i: number) => {
                    return (
                      <option key={i} value={company.id}>{company.name}</option>
                    );
                  })
                }
              </select>
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label>ID Tarjeta</label>
              <select
                className="form-control"
                name="data.cardId"
                onChange={handleChange}
                value={values.data.cardId}
              >
                <option value="">Indistinto</option>
                {
                  cards.map((card: any, i: number) => {
                    return (
                      <option key={i} value={card.id}>{card.name}</option>
                    );
                  })
                }
              </select>
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label>ID Banco</label>
              <select
                className="form-control"
                name="data.bankId"
                onChange={handleChange}
                value={values.data.bankId}
              >
                <option value="">Indistinto</option>
                {
                  banks.map((bank: any, i: number) => {
                    return (
                      <option key={i} value={bank.id}>{bank.name}</option>
                    );
                  })
                }
              </select>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state: any): any => {
  return {
    cards: state.cards,
    banks: state.banks,
    companies: state.companies,
  };
};

export default connect(mapStateToProps)(PaymentMethods);



// WEBPACK FOOTER //
// ./src/containers/Module/Types/PaymentMethods.tsx